var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.check)?_c('i',{staticClass:"fa fa-check"}):_c('i',{staticClass:"fa fa-times"})])}
var staticRenderFns = []

export { render, staticRenderFns }